import { IpIcon } from './IpIcon';

/**
 * author: Michael Richins
 * id 4560EF32-158B-40B1-829E-A078219A808A
 * name ip
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ip.svg
 * tags
 */
export const InternetProtocolIcon = IpIcon;
export default InternetProtocolIcon